import { updatePaymentMethod as mutation } from "../../lib/graphql";
import showToaster from '../../helpers/toastrMessgaes/showToaster';
import axios from 'axios';

async function submit(values, dispatch) {

    try {
        const response = await axios.post('/graphql', {
            query: mutation,
            variables: {
                paymentMethodId: parseInt(values?.paymentMethodId)
            }
        }, {
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json'
            },
            withCredentials: true
        })

        const { data } = await response?.data;

        if (data?.updatePaymentMethod?.status == 200) {
            showToaster({ messageId: 'updatePaymentMethod', toasterType: 'success' });
        } else {
            dispatch(setLoaderComplete('registerLoading'));
            let errorMessage = data?.updatePaymentMethod?.errorMessage
            showToaster({ messageId: 'errorMessage', requestContent: errorMessage, toasterType: 'error' });
        }

    } catch (error) {
        return false;
    }
}

export default submit;